import { render, staticRenderFns } from "./PermissionMenu.vue?vue&type=template&id=333a8612&scoped=true"
import script from "./PermissionMenu.vue?vue&type=script&lang=js"
export * from "./PermissionMenu.vue?vue&type=script&lang=js"
import style0 from "./PermissionMenu.vue?vue&type=style&index=0&id=333a8612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a8612",
  null
  
)

export default component.exports